"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ConfirmButton = exports.FormAlert = void 0;

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of"),
    _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf),
    _classCallCheck2 = require("babel-runtime/helpers/classCallCheck"),
    _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
    _createClass2 = require("babel-runtime/helpers/createClass"),
    _createClass3 = _interopRequireDefault(_createClass2),
    _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn"),
    _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2),
    _inherits2 = require("babel-runtime/helpers/inherits"),
    _inherits3 = _interopRequireDefault(_inherits2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _Dialog = require("office-ui-fabric-react/lib/Dialog"),
    _Button = require("office-ui-fabric-react/lib/Button");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
} // props - cancel_callback, message=""/alert={title:"", message:""}, confirm_callback, confirm_text, cancel_text
//


var FormAlert = exports.FormAlert = function (a) {
  return _react2.default.createElement(_Dialog.Dialog, {
    hidden: "alert" in a ? null === a.alert.message : null === a.message,
    onDismiss: a.cancel_callback,
    dialogContentProps: {
      type: _Dialog.DialogType.normal,
      title: "alert" in a ? a.alert.title : a.title ? a.title : "Alert",
      subText: "alert" in a ? a.alert.message : a.message
    },
    modalProps: {
      isBlocking: "no_cancel_button" in a || !1,
      containerClassName: "ms-dialogMainOverride"
    }
  }, _react2.default.createElement(_Dialog.DialogFooter, null, a.confirm_text && a.confirm_callback && _react2.default.createElement(_Button.DefaultButton, {
    primary: !("reverse" in a),
    onClick: function b() {
      a.cancel_callback(), a.confirm_callback();
    },
    text: a.confirm_text
  }), _react2.default.createElement(_Button.DefaultButton, {
    primary: "reverse" in a,
    onClick: a.cancel_callback,
    text: a.cancel_text ? a.cancel_text : "OK"
  })));
},
    ConfirmButton = exports.ConfirmButton = function (a) {
  function b(a) {
    (0, _classCallCheck3.default)(this, b);
    var c = (0, _possibleConstructorReturn3.default)(this, (b.__proto__ || (0, _getPrototypeOf2.default)(b)).call(this, a));
    return c.state = {
      dialog: !1
    }, c.setD = c.setD.bind(c), c.resetD = c.resetD.bind(c), c.confirmD = c.confirmD.bind(c), c;
  }

  return (0, _inherits3.default)(b, a), (0, _createClass3.default)(b, [{
    key: "setD",
    value: function a() {
      this.setState({
        dialog: !0
      });
    }
  }, {
    key: "resetD",
    value: function a() {
      this.setState({
        dialog: !1
      });
    }
  }, {
    key: "confirmD",
    value: function a() {
      this.setState({
        dialog: !1
      }, this.props.onClick);
    }
  }, {
    key: "render",
    value: function a() {
      return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement("span", {
        onClick: this.setD
      }, this.props.children || _react2.default.createElement(_Button.DefaultButton, {
        text: this.props.text
      })), this.state.dialog && _react2.default.createElement(FormAlert, (0, _extends3.default)({
        message: "Are you Sure?",
        confirm_text: "Yes",
        cancel_text: "No"
      }, this.props, {
        cancel_callback: this.resetD,
        confirm_callback: this.confirmD,
        no_cancel_button: !0
      })));
    }
  }]), b;
}(_react2.default.Component);